import React from 'react';
import Container from '../../../../components/Container';
import styles from './Desktop.module.css';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import Content from '../../../../components/Content';
import Body from '../../components/Body';
import EmailReceipt from '../../components/EmailReceipt';
import TextReceipt from '../../components/TextReceipt';

export default function Desktop(props) {
  const { popup } = props;

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case 'emailReceipt': {
        return <EmailReceipt {...props} />;
      }
      case 'textReceipt': {
        return <TextReceipt {...props} />;
      }
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: "30%" };
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (popup && popup.type === "popup") {
      popupStyle = { width: "30%" };
    } else if (popup && popup.type === "textReceipt") {
      popupStyle = { width: "30%", position: 'absolute', top: '40px' };
    } else if (popup && popup.type === "emailReceipt") {
      popupStyle = { width: "30%", height: "50%", position: 'absolute', top: '40px' };
    }
    return popupStyle;
  };

  return (
    <Container style={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Content style={styles.content}>
        <Body {...props} />
      </Content>
    </Container>
  )
}
